// src/services/authService.js
//
// Backend'in Supabase Auth tabanlı /api/auth/* uçlarıyla konuşan servis.
// Login.js / Register.js / App.js SADECE bu fonksiyonları çağırır,
// fetch/token detaylarıyla hiç uğraşmaz.

import { apiClient, tokenStorage } from './api';

// Backend'den dönen Supabase user objesini bizim uygulamanın kullandığı
// sade { id, username, email, avatar } şekline çevirir.
export function mapSupabaseUserToAppUser(supabaseUser) {
  if (!supabaseUser) return null;
  const meta = supabaseUser.user_metadata || {};
  return {
    id: supabaseUser.id,
    email: supabaseUser.email,
    username: meta.username || (supabaseUser.email ? supabaseUser.email.split('@')[0] : 'kullanici'),
    avatar: meta.avatar_url || null
  };
}

// POST /api/auth/register  Body: { email, password, username }
// NOT: Supabase projesinde "e-posta doğrulama zorunlu" ayarı açıksa
// dönen session null olabilir (kullanıcı e-postasını onaylayana kadar
// giriş yapamaz). Çağıran taraf (Register.js) bunu kontrol etmeli.
export async function register({ email, password, username }) {
  const res = await apiClient.post('/auth/register', { email, password, username });
  const { user, session } = res.data || {};

  if (session?.access_token) {
    tokenStorage.setTokens(session.access_token, session.refresh_token);
  }

  return {
    user: mapSupabaseUserToAppUser(user),
    requiresEmailConfirmation: !session
  };
}

// POST /api/auth/login  Body: { email, password }
export async function login({ email, password }) {
  const res = await apiClient.post('/auth/login', { email, password });
  const { user, session } = res.data || {};

  if (session?.access_token) {
    tokenStorage.setTokens(session.access_token, session.refresh_token);
  }

  return mapSupabaseUserToAppUser(user);
}

// GET /api/auth/me  -> sayfa yenilendiğinde token'ın hâlâ geçerli olup
// olmadığını ve güncel kullanıcı bilgisini doğrulamak için kullanılır.
export async function fetchCurrentUser() {
  const res = await apiClient.get('/auth/me');
  const baseUser = mapSupabaseUserToAppUser(res.data?.user);

  // /auth/me ham JWT claim'lerini döndürüyor — avatar_url, bio gibi gerçek
  // profil alanları (Cloudinary'ye yüklenen resim dahil) burada hiç gelmiyor,
  // çünkü bunlar profiles tablosunda tutuluyor. Gerçek profili ayrıca
  // çekip birleştiriyoruz ki sayfa yenilenince avatar kaybolmasın.
  try {
    const profileRes = await apiClient.get('/profiles');
    if (profileRes?.data) {
      baseUser.avatar = profileRes.data.avatar_url || baseUser.avatar;
      baseUser.username = profileRes.data.username || baseUser.username;
      baseUser.displayName = profileRes.data.display_name || null;
      baseUser.bio = profileRes.data.bio || null;
      baseUser.role = profileRes.data.role || null;
    }
  } catch {
    // Profil çekilemezse en azından temel auth bilgisiyle devam edelim
  }

  return baseUser;
}

export function logout() {
  tokenStorage.clearTokens();
}

export function isAuthenticated() {
  return tokenStorage.hasSession();
}
